export const CATEGORY_CODE_DISPLAY_NAMES: Record<string, string> = {
  jc_LsJrariN5V: "Convalescent Home (CA, MI, NJ, FL)",
  jc_o5vABnBQRj: "Retirement Living Centers (Other States)",
};

export const DEFAULT_QUALIFICATIONS = [
  "CNA",
  "NURSE",
  "RN",
  "LVN",
  "Certified Medication Aide",
  "Medical Technician",
];
